import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Card, Button, Typography, Divider, Tooltip, Modal } from "antd";
import { CheckCircleTwoTone, DeleteTwoTone, ExclamationCircleOutlined } from "@ant-design/icons";
import CustomButton from "../CustomButton";
const OrderBump = ({ orderBump, data, actionHandler, step, customStyle, isMobileSize }) => {
  const { t } = useTranslation();
  const ArrowAnimation = () => (
    <div className="arrow-wrapper">
      <div className="arrow-item">
        <div className="arrow1">
          <div className="arrows next"></div>
          <div className="arrows next"></div>
          <div className="arrows next"></div>
        </div>
      </div>
    </div>
  );

  const IsNullUndefinedEmpty = (value) => {
    try {
      if (value === null || value === undefined || value === "") return true;
      return false;
    } catch (error) {
      return true;
    }
  };

  const formatCurrency = (value, currency = "€", decimals = 2) => {
    if (!value || value === undefined) value = 0;
    value = parseFloat(value);
    let r = value.toFixed(decimals);
    //let r = value.toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    var parts = r.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    r = parts.join(".");

    if (!!currency) return `${r}${currency}`;
    return r;
  };
  const ModalContent = ({ product }) => {
    return (
      <Trans
        i18nKey="orderBump.confirmRemoveContent"
        values={{ name: product.name }}
        components={{ strong: <strong /> }}
      />
    );
  };
  const confirmRemoveBumpPurchase = (product) => {
    Modal.confirm({
      closable: true,
      destroyOnClose: true,
      maskClosable: true,
      title: t("orderBump.confirmRemoveTitle"),
      icon: <ExclamationCircleOutlined />,
      content: <ModalContent product={product} />,
      okText: t("orderBump.confirmYes"),
      cancelText: t("orderBump.confirmNo"),
      okButtonProps: {
        type: "default",
      },

      cancelButtonProps: {
        type: "danger",
      },
      onOk: () => {
        actionHandler("order-bump-remove-from-cart", product);
      },
    });
  };

  const BumpTitle = ({ data }) => (
    <div style={{ color: data.colors?.text || "#44403C" }} className="title">
      {data.title}
    </div>
  );

  // const BumpDescription = ({ data }) => (
  //   <div style={{ color: data.colors.text }} className="description">
  //     {data.description}
  //   </div>
  // );
  const BumpDescription = ({ data }) => {
    if (!data?.description) return <></>;
    const lines = data.description?.split("\n");
    let displayLines = lines;
    if (lines && lines.length > 6) {
      displayLines = lines.slice(0, 5).concat([lines.slice(5).join(" ")]);
    }
    return (
      <div style={{ color: data.colors?.text || "#44403C" }} className="description">
        {displayLines?.map((line, index) => (
          <span key={index}>
            {line}
            {index < displayLines.length - 1 && <br />}
          </span>
        ))}
      </div>
    );
  };

  const BumpPricing = ({ product, data }) => {
    return (
      <div className="pricing">
        <Divider dashed style={{ margin: 6 }} />
        <span style={{ color: data.colors?.text || "#44403C" }}>
          {t("orderBump.bumpPricingPre")}{" "}
          <strong>
            "<em>{product.name}</em>"
          </strong>{" "}
          {t("orderBump.bumpPricingMid")}{" "}
          <strong>
            {product.n_installments > 1 ? `${product.n_installments} x ` : ""}
            {formatCurrency(product.price, "€")}
          </strong>
        </span>
      </div>
    );
  };

  const BumpButton = ({ data, product }) => {
    // Drive CustomButton via its CSS vars (buttonStyle), since .salespark-custom-button
    // sets background-color with !important and would override a plain inline style.
    const buttonColor = data.colors?.button || "#EA580C";
    const bumpButtonStyle = {
      primary: {
        backgroundColor: buttonColor,
        borderColor: buttonColor,
        color: "#ffffff",
        hoverBgColor: buttonColor,
        hoverBorderColor: buttonColor,
        hoverColor: "#ffffff",
      },
    };
    return (
      <div className="button">
        <CustomButton
          buttonStyle={bumpButtonStyle}
          size="large"
          type="primary"
          htmlType="submit"
          onClick={() => addOrderBump({ product_id: product.product_id, offer_id: product.offer_id })}
        >
          <ArrowAnimation /> {data.button_title}
        </CustomButton>
      </div>
    );
  };

  const addOrderBump = (product) => {
    // setOrderBumpPurchased({ ...orderBumpPurchased, [index]: true });
    actionHandler("order-bump-add-to-cart", product);
  };

  const BumpPurchased = ({ data, product }) => {
    return (
      <div style={{ paddingTop: 15 }}>
        {isMobileSize === true && (
          <Card size="small" className="bump-purchased">
            <div className="bump-purchased-content">
              <div>
                <div className="bump-purchased-content-title">
                  <CheckCircleTwoTone twoToneColor={"#52c41a"} /> <span>{t("orderBump.bumpPurchasedTitle")}</span>
                </div>
                <div className="bump-purchased-content-sub-title">
                  <Trans
                    i18nKey="orderBump.bumpPurchasedSubtitle"
                    values={{ name: product.name }}
                    components={{ strong: <strong /> }}
                  />
                </div>
              </div>
            </div>
            <div style={{ paddingBottom: 8, textAlign: "center" }}>
              {/* <Tooltip title="Remover produto das compras">
                <div className="bump-delete-icon">
                  <DeleteTwoTone
                    twoToneColor={"#ff6b72"}
                    className="as-link"
                    onClick={() => confirmRemoveBumpPurchase(product)}
                  />
                </div>
              </Tooltip> */}
              <Button type="link" danger onClick={() => confirmRemoveBumpPurchase(product)}>
                {t("orderBump.removeFromCart")} <DeleteTwoTone twoToneColor={"#ff6b72"} />
              </Button>
            </div>
          </Card>
        )}
        {isMobileSize !== true && (
          <Card size="small" className="bump-purchased">
            <div className="bump-purchased-content">
              <div>
                <div className="bump-purchased-content-title">
                  <CheckCircleTwoTone twoToneColor={"#52c41a"} /> <span>{t("orderBump.bumpPurchasedTitle")}</span>
                </div>
                <div className="bump-purchased-content-sub-title">
                  <Trans
                    i18nKey="orderBump.bumpPurchasedSubtitle"
                    values={{ name: product.name }}
                    components={{ strong: <strong /> }}
                  />
                </div>
              </div>
              <div style={{ paddingLeft: 10 }}>
                <Tooltip title={t("orderBump.removeFromCart")}>
                  <div className="bump-delete-icon">
                    <DeleteTwoTone twoToneColor={"#ff6b72"} className="as-link" onClick={() => confirmRemoveBumpPurchase(product)} />
                  </div>
                </Tooltip>
              </div>
            </div>
          </Card>
        )}
      </div>
    );
  };

  const OrderBumpComponent = () => {
    if (IsNullUndefinedEmpty(orderBump)) return <></>;
    if (IsNullUndefinedEmpty(orderBump?.data) || IsNullUndefinedEmpty(orderBump?.product)) return <></>;
    //console.log("orderBump", data.purchase_products);
    const purchased = data.purchase_products.filter((p) => p.product_id === orderBump.product.product_id && p.offer_id === orderBump.product.offer_id).length;

    return (
      <>
        {purchased === 1 && <BumpPurchased data={orderBump.data} product={orderBump.product} />}
        {purchased === 0 && (
          <div className={`${step === 1 && data.payment_method !== undefined ? "fade-in" : ""}`}>
            <div
              style={{
                "--order-bump": orderBump.data.colors?.border || "#FB923C",
                backgroundColor: orderBump.data.colors?.background || "#FFF7ED",
              }}
              key={orderBump.product.product_id}
              className="order-bump-container"
            >
              <div>
                <BumpTitle data={orderBump.data} />

                <BumpDescription data={orderBump.data} />
                <BumpPricing product={orderBump.product} data={orderBump.data} />
                <BumpButton data={orderBump.data} product={orderBump.product} />
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return <OrderBumpComponent />;
};

export default OrderBump;
